import {Fragment, useEffect, useState} from 'react';

import {ConfirmDialogService, FormatDisplay, ToastService, useDataTable, useDialogCrup, useForm, useToolbar} from '@iamsoftware/react-hooks';
import {CertGdtProcessingService as Service} from './CertGdtProcessingService';
import {CommonService} from '../../../service/CommonService';
import {Button} from 'primereact/button';
import {Dialog} from 'primereact/dialog';
import {InputText} from 'primereact/inputtext';

export const CertGdtProcessing = ()=>{
  const dataKey = 'taxWithholdCertId';
  const header = 'Xử lý chứng từ CQT';

  const [displayToken, setDisplayToken] = useState(false);
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [tokenContent, setTokenContent] = useState('');
  const [ckey, setCkey] = useState('');
  const [cvalue, setCvalue] = useState('');
  const [checkResult, setCheckResult] = useState<any>(null);
  const [submitting, setSubmitting] = useState(false);

  const getCaptcha = () => {
    CommonService.getCaptcha().then(data => {
      setCkey(data.key);
      setTokenContent(data.content);
    });
  }

  const showCheck = (item: any) => {
    setSelectedItem(item);
    setCheckResult(null);
    setCvalue('');
    getCaptcha();
    setDisplayToken(true);
  }

  const doCheck = () => {
    if (!submitting && cvalue) {
      setSubmitting(true);
      Service.getGdtChecking(selectedItem[dataKey], {ckey, cvalue}).then(result => {
        setCheckResult(result);
        if (result?.success === 'N') {
          getCaptcha();
          setCvalue('');
        }
        setSubmitting(false);
      }).catch(() => {
        setSubmitting(false);
      });
    }
  }

  const {render: renderDataTable, reloadLazyData} = useDataTable({
    tableHeader: header,
    dataKey,
    columns:[
      {field:'fromPartyName', header:'Người nộp thuế', matchMode:'contains', minWidth:150},
      {field:'fromPartyTaxId', header:'MST NNT', matchMode:'contains', minWidth:150},
      {field:'templateForm', header:'Mẫu số', matchMode:'contains', minWidth:150},
      {field:'templateSerial', header:'Ký hiệu', matchMode:'contains', minWidth:150},
      {field:'templateNoInt', header:'Số chứng từ', matchMode:'contains', minWidth:150},
      {field:'status', header:'Trạng thái', matchMode:'contains', minWidth:150},
      {field:'fromPartySignedDate', header:'Ngày PH', minWidth:150, dataType:'date-time'},
      {field:'messageId', header:'Id', matchMode:'contains', minWidth:150},
      {field:'processedDate', header:'processedDate', minWidth:150, dataType:'date-time'},
      {field:'gdtExists', header:'Tồn tại trên HT TCT', matchMode:'contains', minWidth:150},
    ],
    indexColumnWidth:45,
    actionColumnWidth:180,
    initActions(items: Array<any>) {
      if (items){
        items.forEach(item =>{
          item.actions = [
            {icon: 'pi pi-check', title: 'Kiểm tra chứng từ đã tồn tại', className: 'p-button-info', command: () => showCheck(item)},
            {icon: 'pi pi-pencil', title: 'Cập nhật lại mã thông điệp', className: 'p-button-warning', command: () => update(item)},
            {icon: 'pi pi-send', title: 'Gửi lại yêu cầu cấp mã', className: 'p-button-secondary', command: () => doResendCert(item)},
            {icon: 'pi pi-download', title: 'Kéo về mã thông điệp', className: 'p-button-success', command: () => doPullMessage(item)},
          ]
        })
      }
    },
    getList(lazyLoadEvent: any): Promise<any> {
      return Service.getList(lazyLoadEvent).then()
    }
  })

  const {render: renderDialogCrup, update} = useDialogCrup({
    header:'Cập nhật lại mã thông điệp',
    dataKey,
    fields:[
      {field:'messageId', header:'Mã thông điệp', required:true, className:'md:col-12'}
    ],
    width:'40rem',
    updateItem(id: string, item: any): Promise<any> {
      return Service.updateMessageId(id, item).then()
    }
  })

  const doResendCert = (item: any) => {
    if (item[dataKey]){
      ConfirmDialogService.confirm('Xác nhận','Bạn có muốn gửi lại yêu cầu cấp mã?',() =>{
        Service.resendCert(item[dataKey]).then(() =>{
          ToastService.success();
          reloadLazyData();
        })
      })
    }
  }

  const doPullMessage = (item: any) => {
    if (item[dataKey]){
      ConfirmDialogService.confirm('Xác nhận','Bạn có muốn kéo về mã thông điệp?',() =>{
        Service.pullMessage(item[dataKey]).then(() =>{
          ToastService.success();
          reloadLazyData();
        })
      })
    }
  }

  const renderTokenDialog = () => {
    const footer = (
      <div>
        {!(checkResult?.success === 'Y') && (
          <Button label="Kiểm tra" icon="pi pi-check" className="p-button-raised mr-2" onClick={doCheck} disabled={!cvalue} />
        )}
        <Button label="Đóng" icon="pi pi-times" className="p-button-raised p-button-text p-button-plain" onClick={() => setDisplayToken(false)} />
      </div>
    );

    return (
      <Dialog header="Kiểm tra chứng từ tồn tại trên TCT" visible={displayToken} style={{width: '500px'}} onHide={() => setDisplayToken(false)} footer={footer} position="top">
        <div className="grid p-fluid">
          {tokenContent && (
            <div className="col-9 text-center">
              <div dangerouslySetInnerHTML={{__html: tokenContent}}></div>
            </div>
          )}
          <div className="col-3">
            <Button icon="pi pi-refresh" className="p-button-raised" onClick={getCaptcha} />
          </div>
          <div className="col-12 mt-2">
            <InputText value={cvalue} onChange={(e) => setCvalue(e.target.value)} onKeyDown={(e) => { if(e.key === 'Enter') doCheck(); }} placeholder="Mã xác nhận"/>
          </div>
        </div>
        {checkResult && (
          <div className="grid mt-2">
            <div className="col-12">
              {checkResult.success === 'N' ? (
                <b style={{color: 'red'}}>{checkResult.message}</b>
              ) : (
                <b>{checkResult.message}</b>
              )}
            </div>
          </div>
        )}
      </Dialog>
    );
  }

  return (
    <div className="grid">
      <div className="col-12 py-0" style={{maxHeight: 'calc(100vh - 12rem)'}}>
        {renderDataTable()}
      </div>
      {renderDialogCrup()}
      {renderTokenDialog()}
    </div>
  )
}
